var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoNotification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1506_6062)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.7517,
    y: 0.943359,
    width: 52.3933,
    height: 52.3933,
    rx: 11.2001,
    transform: "rotate(12 18.7517 0.943359)",
    fill: "#077882",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.350001,
    y: 17.0121,
    width: 51.6933,
    height: 51.6933,
    rx: 10.8501,
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.350001,
    y: 17.0121,
    width: 51.6933,
    height: 51.6933,
    rx: 10.8501,
    stroke: "#D9D9D9",
    strokeWidth: 0.700002
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2547 50.0473H18.3405C17.2711 50.0473 16.45 49.1556 16.45 48.1076C16.45 47.3456 16.8088 46.6283 17.4185 46.1711C18.7284 45.1889 18.6397 43.6286 18.7169 42.1628C18.8095 40.404 19.5274 38.6445 20.65 37.4473",
    stroke: "#077882",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2749 35.8727C24.1105 35.5339 24.9483 35.3477 25.9026 35.3477C29.7297 35.3477 32.8872 38.3425 33.0884 42.1632C33.1655 43.629 33.0768 45.1893 34.3868 46.1715C34.9535 46.5965 35.3035 47.2463 35.35 47.9477",
    stroke: "#077882",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.325 33.3785C24.325 34.2484 25.0301 35.3473 25.9 35.3473C26.7698 35.3473 27.475 34.2484 27.475 33.3785C27.475 32.5087 26.7698 32.1973 25.9 32.1973C25.0301 32.1973 24.325 32.5087 24.325 33.3785Z",
    stroke: "#077882",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.05 50.0488C29.05 51.7886 27.6398 53.1988 25.9 53.1988C24.1603 53.1988 22.75 51.7886 22.75 50.0488",
    stroke: "#077882",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4 53.1973L15.3999 32.1973",
    stroke: "#077882",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1506_6062"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70.0003,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoNotification);
export default __webpack_public_path__ + "static/media/noNotification.0d72cf0209b27562435913cd0384abaf.svg";
export { ForwardRef as ReactComponent };